import { KatalComponent, register } from '../../shared/base';

/**
 * @component {kat-table} KatalTable Component allows user to have a flow styled table.  Inside the kat-table tag you can create your table just like you would in native html: <kat-table-head>,<kat-table-body>,<kat-table-row>,<kat-table-cell>, and <kat-table-footer>.
 * @contentProvided This is to let users know the components expects in inner html to be completed
 * @example SimpleTable {"content": "<kat-table-head><kat-table-row><kat-table-cell>Header 1</kat-table-cell><kat-table-cell>Header 2</kat-table-cell></kat-table-row></kat-table-head><kat-table-body><kat-table-row><kat-table-cell>Value 1</kat-table-cell><kat-table-cell>Value 2</kat-table-cell></kat-table-row></kat-table-body><kat-table-footer></kat-table-footer>"}
 * @status Production
 * @themes flo
 */
@register('kat-table')
export class KatalTable extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  constructor() {
    super(KatalTable.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();

    // the 'role' attribute should be 'table'
    this.setAttribute('role', 'table');
  }
}
